// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.75 3.5V12.5M8.5 3.5V12.5M2.75 8H8.5',
  'M11.25 8.25L13.25 6.75V12.5',
];
